// `hex` = fundo "cheio"; `textColor` = texto sobre `hex`.
// `mainColor` = cor representativa em texto/borda contra fundo claro
// (necessário para BRANCA, cujo hex se confunde com o fundo do app).
export const EQUIPES = [
  { value: 'PRETA', label: 'Preta', hex: '#1a1a1a', textColor: '#ffffff', mainColor: '#1a1a1a' },
  { value: 'BRANCA', label: 'Branca', hex: '#f5f5f5', textColor: '#1a1a1a', mainColor: '#525252' },
  { value: 'ROXA', label: 'Roxa', hex: '#7c3aed', textColor: '#ffffff', mainColor: '#7c3aed' },
  { value: 'VERDE', label: 'Verde', hex: '#10b981', textColor: '#ffffff', mainColor: '#10b981' }
]

// Visual padrão para acampante sem equipe (equipe = null no banco).
export const SEM_EQUIPE = {
  value: null,
  label: 'Sem equipe',
  hex: '#e5e7eb',
  textColor: '#1f2937',
  mainColor: '#6b7280'
}

export function getEquipe(value) {
  if (value === null || value === undefined) return SEM_EQUIPE
  return EQUIPES.find(e => e.value === value) || null
}
